
// Dependencies
import { PageEditor } from "@/assets/scripts/PageEditor/PageEditor";
import { defineComponent, PropType } from "vue";
// Components
import File from "@/components/Icons/File.vue";

export default defineComponent({
  name: "FileSelect",
  props: {
    active: {
      type: String,
      required: true
    },
    editors: {
      type: Object as PropType<Map<string, PageEditor>>,
      required: true
    }
  },
  emits: ["switch", "close"],
  components: { File }
});
